import styled from 'styled-components';

import { c14142E, c1D1D37 } from '#/colors';

export const Card = styled.div`
  background-color: ${c14142E};
  border-radius: 7px;
  font-weight: 500;
  padding: 16px 21px 19px;
`;

export const CardTitle = styled.h2`
  margin: 0;
  font-size: 13px;
  line-height: 12px;
  font-weight: 500;
  margin-bottom: 21px;
  opacity: 0.7;
`;

export const CardSecondary = styled.div`
  background: transparent;
  border: 1px solid ${c1D1D37};
  border-radius: 7px;
  font-size: 11px;
  font-weight: 500;
  padding: 16px;
`;
